export const FOREIGN_RESIDENCY_DATA_REQUEST = 'FOREIGN_RESIDENCY_DATA_REQUEST';
export const FOREIGN_RESIDENCY_DATA_SUCCESS = 'FOREIGN_RESIDENCY_DATA_SUCCESS';
export const FOREIGN_RESIDENCY_DATA_FAIL = 'FOREIGN_RESIDENCY_DATA_FAIL';
